import React from "react";
import { Link } from "react-router-dom";
import ImportantToKnow from "../components/ImportantToKnow";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

import { useLanguage } from "../context/LanguageContext";

const Sitemap = () => {
  const { t } = useLanguage();

  /*
   * ============================================================
   * MENU LABELS
   *
   * These should ideally come from your translation API.
   * The fallback English values keep the sitemap working.
   * ============================================================
   */

  const menuItems = {
    home: t("menu.menu0", "Home"),
    bookACar: t("menu.menu1", "Book a car"),
    ourCars: t("menu.menu2", "Our cars"),
    modifyReservation: t("menu.menu3", "Modify reservation"),
    about: t("menu.menu4", "About us"),
    faq: t("menu.menu5", "FAQ"),
    contact: t("menu.menu6", "Contact us"),
    terms: t("menu.menu11", "Terms & Conditions"),
    sitemap: t("menu.menu12", "Sitemap"),
    rates: t("menu.menu13", "Rates per day"),
    offers: t("menu.menu14", "Special offer"),
    policy: t("menu.menu15", "Policy"),
  };

  /*
   * ============================================================
   * SITEMAP LINKS
   * ============================================================
   */

  const sitemapLinks = [
    {
      title:`${t("othersnewstatics.othersnewstatic30", "Booking")}`,
      icon: "🚗",
      links: [
        {
          label: menuItems.home,
          path: "/",
        },
        {
          label: menuItems.bookACar,
          path: "/bookacar",
        },
        {
          label: menuItems.ourCars,
          path: "/ourcars",
        },
        {
          label: menuItems.modifyReservation,
          path: "/modifyreservation",
        },
      ],
    },

    {
      title: `${t("othersnewstatics.othersnewstatic16", "Information")}`,
      icon: "ℹ️",
      links: [
        {
          label: menuItems.rates,
          path: "/rates",
        },
        {
          label: menuItems.about,
          path: "/about",
        },
        {
          label: menuItems.offers,
          path: "/offer",
        },
        {
          label: menuItems.policy,
          path: "/policy",
        },
      ],
    },

    {
      title: `${t("othersnewstatics.othersnewstatic31", "Help & Support")}`,
      icon: "💬",
      links: [
        {
          label: menuItems.faq,
          path: "/faq",
        },
        {
          label: menuItems.terms,
          path: "/termsconditions",
        },
        {
          label: menuItems.contact,
          path: "/contact",
        },
        {
          label: menuItems.sitemap,
          path: "/sitemap",
        },
      ],
    },
  ];

  return (
    <div className="sitemap-page">

      {/* ======================================================
          HERO
      ====================================================== */}
<div className="bg-box ">
      <section className="modify1 sitemap-hero">

        <div className="container">

          <div className="sitemap-hero-content">

            <span className="sitemap-eyebrow">
            {t("othersnewstatics.othersnewstatic26", "WEBSITE NAVIGATION")}
            
            </span>

            <h1>
              {menuItems.sitemap}
            </h1>

            <p>
            {t("othersnewstatics.othersnewstatic25", "Explore all the important sections of our website in one place.")}
            </p>

          </div>

        </div>

      </section>
</div>

      {/* ======================================================
          SITEMAP CONTENT
      ====================================================== */}

      <section className="sitemap-content">

        <div className="container">

          <div className="sitemap-grid">

            {sitemapLinks.map(
              (section, sectionIndex) => (

                <div
                  className="sitemap-card"
                  key={sectionIndex}
                >

                  {/* CARD HEADER */}

                  <div className="sitemap-card-header">

                    <div className="sitemap-card-icon">
                      {section.icon}
                    </div>

                    <h2>
                      {section.title}
                    </h2>

                  </div>


                  {/* LINKS */}

                  <div className="sitemap-links">

                    {section.links.map(
                      (item, index) => (

                        <Link
                          to={item.path}
                          className="sitemap-link"
                          key={index}
                        >

                          <span className="sitemap-link-arrow">
                            →
                          </span>

                          <span>
                            {item.label}
                          </span>

                        </Link>

                      )
                    )}

                  </div>

                </div>

              )
            )}

          </div>


          {/* ==================================================
              QUICK ACCESS
          ================================================== */}

          <div className="sitemap-bottom">

            <div className="sitemap-bottom-inner">

              <div>

                <span className="sitemap-bottom-label">
                  {t("othersnewstatics.othersnewstatic27", "QUICK ACCESS")}
                </span>

                <h3>
                {t("othersnewstatics.othersnewstatic28", "Ready to book your car")}?
                </h3>

                <p>
                {t("othersnewstatics.othersnewstatic29", "Find the perfect car and start your journey today.")}?
                 </p>

              </div>

              <Link
                to="/bookacar"
                className="sitemap-book-btn"
              >
                {t("bookingengine.bookingengine9", "Continue")}
                <span>→</span>
              </Link>

            </div>

          </div>

        </div>

      </section>
 <ImportantToKnow />
    </div>
  );
};

export default Sitemap;